import { Rocket, ArrowUpRight, Mail } from "lucide-react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const PERKS = [
  "Unlimited manufacturing cost estimates",
  "Priority AI analysis & regional costing",
  "Direct sourcing support from GloGrid's network",
];

export const UpgradeModal = () => {
  const { showUpgrade, setShowUpgrade } = useAuth();
  return (
    <Dialog open={showUpgrade} onOpenChange={setShowUpgrade}>
      <DialogContent className="max-w-md" data-testid="upgrade-modal">
        <DialogHeader>
          <div className="mb-2 flex h-11 w-11 items-center justify-center rounded-sm bg-primary text-primary-foreground">
            <Rocket className="h-5 w-5" />
          </div>
          <DialogTitle className="font-title text-xl">You've used your 3 free estimates</DialogTitle>
          <DialogDescription>
            Upgrade with GloGrid to keep estimating manufacturing cost, tooling and sourcing — India Cost, Global Reach.
          </DialogDescription>
        </DialogHeader>

        <ul className="space-y-2">
          {PERKS.map((p) => (
            <li key={p} className="flex items-start gap-2 text-sm">
              <span className="mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-primary" /> {p}
            </li>
          ))}
        </ul>

        <div className="mt-2 space-y-2">
          <a href="https://glogrid.com" target="_blank" rel="noopener noreferrer" data-testid="upgrade-glogrid-link">
            <Button className="h-11 w-full rounded-sm">
              Upgrade with GloGrid <ArrowUpRight className="ml-2 h-4 w-4" />
            </Button>
          </a>
          <a href="mailto:sales@glogrid.com?subject=GloGrid%20Part%20Cost%20Estimate%20Subscription" data-testid="upgrade-email-link">
            <Button variant="outline" className="h-11 w-full rounded-sm">
              <Mail className="mr-2 h-4 w-4" /> Email GloGrid sales
            </Button>
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
